// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ContextMaker$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/ContextMaker.res.mjs";

var Api = {
  name: "ProfileAvatarContext"
};

var include = ContextMaker$LiteracyplanetClientFlags.Make(Api);

var use = include.use;

function ProfileAvatarContext(props) {
  var fetchAvatars = use();
  var match = React.useState(function () {
        
      });
  var setAvatars = match[1];
  var avatarIds = match[0];
  React.useEffect((function () {
          var queryAvatars = async function (param) {
            var avatarIds = await fetchAvatars(3);
            return setAvatars(function (param) {
                        return avatarIds;
                      });
          };
          queryAvatars();
        }), []);
  if (avatarIds !== undefined) {
    return props.children(avatarIds);
  } else {
    return props.loading;
  }
}

var initialContext = include.initialContext;

var context = include.context;

var P = include.P;

var Provider = include.Provider;

var ContextMakerProviderNotFound = include.ContextMakerProviderNotFound;

var make = ProfileAvatarContext;

export {
  Api ,
  initialContext ,
  context ,
  P ,
  Provider ,
  ContextMakerProviderNotFound ,
  use ,
  make ,
}
/* include Not a pure module */
